angular.module('app').controller('passwordController', ['$scope', '$http', '$location', '__env', function($scope, $http, $location, __env){

	
	/**
	 * Handles password reset event from the front page and prepares the http request for 
	 * resetting password
	 * sends the http request that should email the user a new password
	 *
	 * @function
	 */
	$scope.reset = function() {
		if($scope.resetForm.$pristine) {

			$scope.resetForm.email.$setDirty();
			
			return;
		} 		

		// make sure there are no errors
		if($scope.resetForm.$valid){

			var email = $scope.typedEmail.replace('+', ' ');
			var data = { 'email': $scope.typedEmail, 'page': $scope.targetPage  };

			$http({
				url: __env.apiBaseUrl + 'login/' + encodeURI($scope.typedEmail) + '/password/reset',
				data: data,
				method: 'put',
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(
			function successCallback(response){
				//console.log('ok');
				// setup the session
				$scope.setErrorMessage('If an account exists, you should receive an email with your credentials.');
				$location.path('/login');

			},
			function errorCallback(response) {
				$scope.setErrorMessage('Invalid Request. Please contact your Account Manager.');
			});
		}
	};

	
}]);